/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Available_FontsInputs */



/**
* | output |
* | --- |
* | "Available Fonts" |
*
* @param {Options_Fonts_Available_FontsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_available_fonts = /** @type {((inputs?: Options_Fonts_Available_FontsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Available_FontsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Polices disponibles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfügbare Schriftarten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri disponibili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступные шрифты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuentes disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("可用字体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なフォント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपलब्ध फ़ॉन्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fontes disponíveis")
	return /** @type {LocalizedString} */ ("Available Fonts")
});